export default "__VITE_ASSET__dd692467__"